export default __webpack_public_path__ + "static/media/Yellow0002.236c8ce0.png";